import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconComponentProps } from '../IconTypes';
import { IconWrapper } from '../IconWrapper';

import { faLocationDot } from '@fortawesome/pro-light-svg-icons';

export type ProLightLocationDotProps = IconComponentProps;

export const ProLightLocationDot = ({
  className,
  onClick,
  iconProps,
  type = 'button',
  ...props
}: ProLightLocationDotProps) => {
  if (onClick) {
    return (
      <IconWrapper
        {...props}
        className={['font-awesome-button', className].join(' ')}
        type={type}
        onClick={onClick}
      >
        <FontAwesomeIcon
          {...iconProps}
          className="font-awesome-icon"
          icon={faLocationDot}
        />
      </IconWrapper>
    );
  }
  return (
    <FontAwesomeIcon
      {...iconProps}
      className={['font-awesome-icon', className].join(' ')}
      icon={faLocationDot}
    />
  );
};

ProLightLocationDot.displayName = 'ProLightLocationDot';
